/* TODO: t() */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Component, ComponentProps } from 'react';
import cx from 'classnames';
import autobind from 'class-autobind';

import OptionList from '../../support/OptionList';

type Props = Omit<ComponentProps<'select'>, 'value' | 'onChange'> & {
  options: Array<any>;
  value: number | string | ObjectOf<any> | null | undefined;
  onChange: (...args: Array<any>) => any;
  block?: boolean;
};

type State = {
  options: ObjectOf<any>;
  selectedValue: ObjectOf<any> | null | undefined;
};

function getExistingValue(value: any, options: OptionList) {
  if (options.length === 0) {
    return null;
  }
  value = value == null ? options.getByIndex(0) : OptionList.toValue(value);
  if (value) {
    value = options.getByID(value.id) || options.getByIndex(0);
  }
  return value;
}

class Dropdown extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    autobind(this);
    let options = new OptionList(this.props.options);

    let value = getExistingValue(this.props.value, options);
    this.state = {
      options: options,
      selectedValue: value,
    };
  }

  componentDidUpdate(oldProps: Props) {
    let newProps = this.props;
    let optionsChanged = oldProps.options !== newProps.options;
    let valueChanged = oldProps.value !== newProps.value;
    if (optionsChanged || valueChanged) {
      let options = optionsChanged
        ? new OptionList(newProps.options)
        : this.state.options;
      let value = getExistingValue(newProps.value, options as any);
      this.setState({
        options: options,
        selectedValue: value,
      });
    }
  }

  render() {
    let { block, options, ...otherProps } = this.props;
    let className = cx({
      dropdown: true,
      block: block,
    });
    // selectedValue can be empty only if options list is empty
    let selectedValue = this.state.selectedValue || {};
    let children = this.state.options.map((option: any) => {
      return (
        <option key={option.id} value={option.id}>
          {option.name}
        </option>
      );
    });
    return (
      <span className={className}>
        <select
          {...otherProps}
          value={selectedValue.id}
          onChange={this._onChange}
        >
          {children}
        </select>
        <span>{selectedValue.name}</span>
      </span>
    );
  }

  _onChange(event: any) {
    let id = event.target.value;
    let value = this.state.options.getByID(id);
    if (value == null) {
      throw new Error('Dropdown: unknown value `' + id + '`');
    }
    this.props.onChange(value.original);
  }
}

export default Dropdown;
